import React, { useState } from 'react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const DeleteAccountScreen = () => {
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone || phone.length < 10) {
      toast.error('Please enter a valid phone number');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/account/delete-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone })
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        toast.error('Something went wrong. Please email support@sellgen.online');
      }
    } catch {
      toast.error('Network error. Please email support@sellgen.online');
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="delete-account-success">
        <div className="max-w-md text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Request Submitted</h2>
          <p className="text-gray-600 text-sm">
            Your account deletion request has been received. We will process it within 30 days 
            and send a confirmation. All your data including products, images, and personal 
            information will be permanently deleted.
          </p>
          <p className="text-gray-500 text-xs mt-4">
            Questions? Email us at support@sellgen.online
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="delete-account-page">
      <div className="max-w-lg mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Delete Your Account</h1>
        <p className="text-sm text-gray-600 mb-6">
          Request deletion of your SellGen AI account and all associated data.
        </p>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-semibold text-red-800 mb-2">What will be deleted:</h3>
          <ul className="text-sm text-red-700 space-y-1">
            <li>- Your account and phone number</li>
            <li>- All uploaded product images</li>
            <li>- All generated product listings (titles, descriptions, tags)</li>
            <li>- All export history and marketing content</li>
            <li>- Any connected platform data (Shopify, etc.)</li>
          </ul>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number (used for login)
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter your registered phone number"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-red-500 focus:border-red-500"
              data-testid="delete-phone-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-red-600 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-red-700 disabled:opacity-50"
            data-testid="delete-submit-btn"
          >
            {loading ? 'Submitting...' : 'Request Account Deletion'}
          </button>
        </form>

        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500">
            <strong>Processing time:</strong> Your request will be processed within 30 days. 
            You can also email us directly at <strong>support@sellgen.online</strong> to request deletion.
            This action is irreversible.
          </p>
        </div>
      </div>
    </div>
  );
};
